import React from 'react'
import { TextareaAutosize, FormControl, FormHelperText } from '@mui/material'

import './stylesIA.css'

export default function InputArea({
  value,
  onChange,
  onBlur,
  fullWidth = true,
  placeholder = 'Digite aqui',
  rows = 4,
  error = false,
  helperText,
  success,
}) {
  function handleBlur() {
    if (onBlur) {
      onBlur()
    }
  }

  return (
    <FormControl fullWidth={fullWidth} variant='filled'>
      <TextareaAutosize
        className='input-textarea-obs'
        value={value}
        onChange={onChange}
        onBlur={handleBlur}
        placeholder={placeholder}
        minRows={rows}
      />
      <FormHelperText
        sx={success ? { color: 'success.main' } : error ? { color: 'error.main' } : {}}
      >
        {helperText}
      </FormHelperText>
    </FormControl>
  )
}
